import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useWorkflowTracking } from '@/hooks/use-workflow-tracking'

import { PageBackButton } from '@/components/common/PageBackButton'
import { ContractDeliveryForm } from '@/components/contract-delivery/contract-delivery-form'
import { useCreateContractDelivery } from '@/hooks/use-contract-delivery-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/contract-deliveries/new',
)({
    component: NewContractDeliveryPage,
})

function NewContractDeliveryPage() {
    const navigate = useNavigate()
    const createMutation = useCreateContractDelivery()
    const workflow = useWorkflowTracking('contract_delivery', {
        operation: 'create',
    })

    const handleCancel = () => {
        workflow.finish('closed')
        void navigate({ to: '/contract-deliveries' })
    }

    return (
        <div className="space-y-5 page-pad">
            <div className="flex items-center gap-3">
                <PageBackButton onBack={handleCancel} />
                <h1 className="text-xl font-semibold tracking-tight">
                    {m.cdo_new_title()}
                </h1>
            </div>
            <ContractDeliveryForm
                isPending={createMutation.isPending}
                onCancel={handleCancel}
                onValidationError={() => workflow.step('validation_failed')}
                onInteract={() => workflow.interact('details')}
                onSubmit={(data) => {
                    void workflow
                        .run(
                            () => createMutation.mutateAsync(data),
                            (res) => res.data?.id,
                        )
                        .then((res) => {
                            const id = res.data?.id
                            if (id) {
                                void navigate({
                                    to: '/contract-deliveries/$id',
                                    params: { id },
                                })
                            } else {
                                void navigate({ to: '/contract-deliveries' })
                            }
                        })
                        .catch(() => {
                            /* Mutation hook owns the error toast. */
                        })
                }}
            />
        </div>
    )
}
